import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../styles/shared/Modal.css';

const AdminFormModal = ({
  show,
  onClose,
  title,
  subtitle,
  icon,
  notice,
  children,
  footer,
  size,
  dialogClassName = 'admin-modal',
}) => (
  <Modal show={show} onHide={onClose} centered size={size} dialogClassName={dialogClassName}>
    <Modal.Header closeButton>
      <Modal.Title>
        {icon ? <FontAwesomeIcon icon={icon} /> : null}
        <span>{title}</span>
      </Modal.Title>
      {subtitle ? <p className="admin-modal-subtitle">{subtitle}</p> : null}
    </Modal.Header>
    <Modal.Body>
      <div className="admin-modal-shell admin-form-modal-shell">
        {notice ? <div className="admin-modal-inline-notice">{notice}</div> : null}
        {children}
      </div>
    </Modal.Body>
    {footer ? <Modal.Footer>{footer}</Modal.Footer> : null}
  </Modal>
);

export default AdminFormModal;
